(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("editNotificationTemplate", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/notifications/editNotificationTemplateView.html",
            controller: ["frameworkService", "notificationResource", "messageService", "$localStorage", "$state", "$translate", "_", EditNotificationTemplateCtrl],
            controllerAs: "vm"
        };
        function EditNotificationTemplateCtrl(frameworkService, notificationResource, messageService, $localStorage, $state, $translate, _) {
            var vm = this;
            vm.showErrors = false;
            vm.loading = true;
            vm.resetList = [];
            vm.enabledLocalizations = frameworkService.data.tenant.enabledLocalizations;
            var lang = $translate.proposedLanguage() || $translate.use();
            lang = lang.replace("-", "_");
            vm.tinymceOptions = {
                resize: false,
                height: 300,
                plugins: "autoresize code",
                autoresize_max_height: 500,
                language: lang,
                convert_urls: 0
                //init_instance_callback: function (editor) {
                //	console.log("Editor: " + editor.id + " is now initialized.");
                //}
            };
            notificationResource.get({ id: $state.params.id }, function (data) {
                vm.model = data;
                vm.selectedLocalizationId = parseInt($localStorage.currentLocalizationId);
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
                vm.loading = false;
            });
            vm.changeLanguage = function (localizationId) {
                vm.selectedLocalizationId = localizationId;
            };
            vm.save = function () {
                if (vm.saving)
                    return;
                if (vm.form.$valid) {
                    notificationResource.save({ id: $state.params.id }, vm.model, function () {
                        messageService.success("common.changesSaved");
                        vm.resetList = [];
                        vm.saving = false;
                    }, function (error) {
                        messageService.error(error);
                        vm.saving = false;
                    });
                }
                else {
                    vm.showErrors = true;
                }
            };
            vm.reset = function () {
                if (vm.resetting)
                    return;
                vm.resetting = true;
                notificationResource.resetTemplate({ systemName: vm.model.systemName, localizationId: vm.selectedLocalizationId }, function (data) {
                    var template = _.find(vm.model.templates, { localizationId: vm.selectedLocalizationId });
                    template.body = data.body;
                    messageService.success("settings.notifications.resetTemplate.success");
                    if (vm.resetList.indexOf(vm.selectedLocalizationId) === -1)
                        vm.resetList.push(vm.selectedLocalizationId);
                    vm.resetting = false;
                }, function (error) {
                    messageService.error(error);
                    vm.resetting = false;
                });
            };
        }
    });
})();
